import { createStore, applyMiddleware, compose } from 'redux';
import axiosMiddleware from 'redux-axios-middleware';
import createSagaMiddleware from 'redux-saga';
import { routerMiddleware as createRouterMiddleware } from 'connected-react-router';

import getReducer from './reduxModules';
import formContactSagas from './sagas';

import { configureAxios, configureAxiosOptions } from '../auth/axios';
import GeneralsMiddleware from '../middleware/GeneralsMiddleware';

export default function configureStore(initialState, history) {
    const sagaMiddleware = createSagaMiddleware();
    const routerMiddleware = createRouterMiddleware(history);
    const middlewares = [
        axiosMiddleware(configureAxios(), configureAxiosOptions()),
        GeneralsMiddleware,
        sagaMiddleware,
        routerMiddleware,
    ];

    let composeMethod = compose;
    if (!window.YURPLAN_ENV || window.YURPLAN_ENV !== 'prod') {
        composeMethod = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
    }

    const store = createStore(
        getReducer(history),
        initialState,
        composeMethod(applyMiddleware.apply(this, middlewares)),
    );
    sagaMiddleware.run(formContactSagas);

    return store;
}
